<template>
  <div id="walletTransactionsList" v-if="walletTransactionsList">
    <div
      class="my-2"
      v-for="(walletTransaction, index) in walletTransactionsList.list"
      :key="index"
    >
    <v-alert
          v-if="walletTransaction"
            border="left"
            :color="
            walletTransaction.debit?'red':'green'"
            :icon="
            walletTransaction.debit?'mdi mdi-arrow-down':'mdi mdi-arrow-up'"
            outlined
            prominent
            elevation="5"
          >
        
          <strong class="text-gray-900">
              {{
                walletTransaction.credit
                  ? walletTransaction.credit.amount
                  : walletTransaction.debit
                  ? walletTransaction.debit.amount
                  : "" | priceSplitter
              }}
              ریال</strong
            >
            <v-divider class="my-2"></v-divider>
          <div v-if="walletTransaction.description">
            <strong>توضیحات : </strong>
            {{ walletTransaction.description }}
          </div>
          <div class="mt-2" v-if="walletTransaction.transactionDateUtc">
            {{ walletTransaction.transactionDateUtc | moment }}
          </div>
        
        </v-alert>
      <!-- <v-card outlined v-if="walletTransaction">
        <v-card-text>
          <div>
            <v-icon color="success"> mdi mdi-check-circle </v-icon>
            <strong class="text-gray-900">
              {{
                walletTransaction.credit
                  ? walletTransaction.credit.amount
                  : walletTransaction.debit
                  ? walletTransaction.debit.amount
                  : '' | priceSplitter
              }}
              ریال</strong
            >
          </div>
          <v-divider class="my-2"></v-divider>
          <div v-if="walletTransaction.description">
            {{ walletTransaction.description }}
          </div>
          <div v-if="walletTransaction.transactionDateUtc">
            {{ walletTransaction.transactionDateUtc | moment }}
          </div>
        </v-card-text>
      </v-card> -->
    </div>
    <div
      class="mt-1 pagination text-center pt-2"
      v-if="walletTransactionsList.list && walletTransactionsList.list.length"
    >
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    walletTransactionsList: {
      type: Object,
      default: null,
    },
    pageNumberProps: {
      type: Number,
      default: 0,
    },
    itemsPerPageProps: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 10,
      favoriteTypeItems: [],
    };
  },
  created() {
    this.pageNumber = this.pageNumberProps;
    this.itemsPerPage = this.itemsPerPageProps;
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.walletTransactionsList.totalCount / this.itemsPerPage
      );
    },
  },
  watch: {
    pageNumber(after, before) {
      this.$emit('getAllWalletTransactions', after, this.itemsPerPage);
      this.scrollTopFavList();
    },
    itemsPerPage(after, before) {
      this.$emit('getAllWalletTransactions', 1, after);
      this.scrollTopFavList();
    },
  },
  methods: {
    scrollTopFavList() {
      document.getElementById('walletTransactionsList').scrollIntoView();
    },
  },
};
</script>

<style lang="scss" scoped></style>
